export default __webpack_public_path__ + "f50175884a3164e4a7ad0d932bc1586e.png";